__turbopack_context__.v({
  "cta": "tMewUq_cta",
  "fullWidth": "tMewUq_fullWidth",
});
